import type { UUID } from "@/core/types";

export const acuityKeys = {
  base: ["acuity"] as const,
  history: (patientId: UUID) => [...acuityKeys.base, patientId, "history"] as const,
  reasoningOptions: () => [...acuityKeys.base, "reasoning-options"] as const,
} as const;
